module.exports = __webpack_public_path__ + "static/media/8604-f-r-en.298f3223.png";